export default "__VITE_ASSET__1d12d183__"